


  
  

  var faCircleChevronDown = {
    prefix: 'fad',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-32c0-6.1 2.3-12.3 7-17s10.8-7 17-7s12.3 2.3 17 7l87 87 87-87c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17L273 345c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L135 241c-4.7-4.7-7-10.8-7-17z','M239 345c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345z']
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faCircleChevronLeft = {
    prefix: 'fad',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 0c0-6.1 2.3-12.3 7-17L271 135c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-87 87 87 87c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7L167 273c-4.7-4.7-7-10.8-7-17z','M167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273z']
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faCircleChevronRight = {
    prefix: 'fad',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM200 152c0 6.1 2.3 12.3 7 17l87 87-87 87c-4.7 4.7-7 10.8-7 17s2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7L345 273c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17L241 135c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7s-7 10.8-7 17z','M345 239c9.4 9.4 9.4 24.6 0 33.9L241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239z']
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faCircleChevronUp = {
    prefix: 'fad',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 32c0-6.1 2.3-12.3 7-17L239 167c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7L377 271c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-87-87-87 87c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z','M239 167c9.4-9.4 24.6-9.4 33.9 0L377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167z']
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faTriangleExclamation = {
    prefix: 'fad',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      ['M0 440c0 6.9 1.8 13.7 5.3 19.9C12.4 472.3 25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1c3.5-6.2 5.3-13 5.3-19.9c0-7-1.8-14-5.5-20.2l-216-368C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368C1.8 426 0 433 0 440zm288-56a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z','M280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  



export {

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

};
